









































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FbaseClient, FbaseClientService } from '@/services/FbaseClientService';
import { Alert, KInputValidate as KValidate, NoticeClass, NoticeResponse } from '@kasasa/fbase-components/lib';
import { KSpinner, KText, KRadioGroup, KCardFooter, KCardFooterBtn } from '@kasasa/fbase-components';

//todo add custom asynchronous validation
const validationRules: Record<string, { (value: string|number|boolean): boolean|string } []> = {
	name: [KValidate.maxLength(255)],
	title: [KValidate.maxLength(255)],
	fiId: [],
	isInternal: [],
};

@Component({
	components: {
		KSpinner,
		KText,
		KRadioGroup,
		KCardFooter,
		KCardFooterBtn,
	},
})
export default class ClientDetail extends Vue {
	@Prop({ default: false }) readonly canWrite!: boolean;
	@Prop({ default: '' }) readonly clientId!: string;

	client = new FbaseClient();
	clientSvc!: FbaseClientService;
	isDataLoaded = false;

	validationRules: Record<string, { (value: string|number|boolean): boolean|string } []> = {};

	resolve!: (value?: void|PromiseLike<void>|undefined) => void;
	valid = true;


	created(): void {
		this.clientSvc = new FbaseClientService(this.$store);
		if (this.isAddRoute) {
			this.validationRules = validationRules;
			this.validationRules.isInternal.push((value: string|number|boolean) => {
				return Boolean(value) || parseInt(this.client.fiId) < 90000 || 'A client with an FI ID greater than 90000 must be an Internal/Test Client.';
			});
			this.validationRules.isInternal.push((value: string|number|boolean) => {
				return !value || parseInt(this.client.fiId) > 90000 || 'A client with an FI ID less than 90000 cannot be an Internal/Test Client.';
			});
			this.validationRules.fiId.push(KValidate.isNumeric(), KValidate.maxLength(255));
			this.isDataLoaded = true;
			return;
		}

		this.clientSvc.getClient(parseInt(this.clientId)).then(
			resp => {
				this.client = resp.data.data;

				if (!this.client.fiId) {
					this.client.fiId = '';
				}
				this.validationRules = validationRules;
				this.isDataLoaded = true;
			}
		).catch((e) => {
			// can listen for non 401, 403, 500 error?
			if (e.response.status == '404') {
				const a = new Alert(`There was a problem loading client ${this.clientId}. `, NoticeClass.ERROR);
				a.setTimeout(4000);
				this.$store.dispatch('notices/add', a);
			}
		});
	}

	get isAddRoute(): boolean {
		return this.$route.name === 'Add';
	}

	navigateHome(): void {
		// Navigating to home
		this.$router.push({name: 'Home'});
	}

	save(): Promise<void> {
		return new Promise((resolve) => {
			this.upsertClient();
			this.resolve = resolve;
		});
	}


	saveclose(): Promise<void> {
		return new Promise((resolve) => {
			this.upsertClient(true);
			this.resolve = resolve;
		});
	}

	upsertClient(close = false): void {
		if (!this.canWrite) {
			this.navigateHome();
			return;
		}

		this.validateForm();
		if (!this.valid) {
			this.resolve();
			return;
		}

		this.clientSvc.upsertClient(this.client).then(
			resp => {
				this.resolve();
				this.client = resp.data.data;
				this.$parent.$emit('data-updated');
				const success = new Alert(`"${this.client.name}" is successfully saved."`, NoticeClass.SUCCESS);
				success.setTimeout(6000);
				if (close) {
					success.setAcceptLabel('VIEW');
					this.$store.dispatch('notices/add', success).then(
						response => {
							if (response == NoticeResponse.ACCEPT) {
								this.$router.push({name: 'Details', params: {clientId: this.client.id}});
							}
						}
					);
					this.navigateHome();
				} else {
					this.$store.dispatch('notices/add', success);
					if (this.isAddRoute) {
						this.$router.push({name: 'Details', params: {clientId: this.client.id}});
					}
				}
			}
		)
			.catch((e) => {
				this.resolve();
				// can listen for non 401, 403, 500 error?
				let message = `There was a problem saving client ${this.clientId}. `;
				switch (e.response.status) {
					case 422:
					case 409:
						if (typeof e.response.data.error.message !== undefined) {
							message = e.response.data.error.message;
							if (e.response.data.error.field !== null) {
								const invalidValue = this.client[e.response.data.error.field as keyof FbaseClient];
								this.validationRules[e.response.data.error.field].push(
									(value: string|boolean|number) => {
										return value !== invalidValue || message;
									}
								);
							}
						}
						break;
				}
				const a = new Alert(message, NoticeClass.ERROR);
				this.$store.dispatch('notices/add', a);
			});
	}

	validateForm(): void {
		(this.$refs.form as Vue & { validate: () => boolean }).validate();
	}

}
